import { RouteRecordRaw } from 'vue-router';
import Layout from '@/layout/index.vue';
export const basicRoutes: RouteRecordRaw[] = [
  {
    path: '/gpt',
    name: 'Gpt',
    meta: {
      title: 'GPT对话',
      requiresAuth: false
    },
    component: () => import('@/views/gpt/index.vue'),
  },
  {
    path: '/introduction-weview',
    name: 'Introduction',
    component: () => import('@/views/introductionWebview/index.vue'),
  },
  {
    path: '/',
    redirect: '/train',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
      },
      {
        path: 'train',
        name: 'Train',
        component: () => import('@/views/train/index.vue'),
      },
      {
        path: 'examine',
        name: 'Examine',
        component: () => import('@/views/examine/index.vue'),
      },
      {
        path: 'mine',
        name: 'Mine',
        component: () => import('@/views/mine/index.vue'),
      },
      {
        path: 'renew',
        name: 'Renew',
        meta: {
          title: '续费',
        },
        component: () => import('@/views/renew/index.vue'),
      },
      {
        path: 'device',
        name: 'Device',
        meta: {
          title: '设备管理',
        },
        component: () => import('@/views/device/index.vue'),
      },
      {
        path: 'setting',
        name: 'Setting',
        meta: {
          title: '通用设置',
        },
        component: () => import('@/views/setting/index.vue'),
      },
      {
        path: 'others',
        name: 'others',
        meta: {
          title: '更多',
        },
        component: () => import('@/views/others/index.vue'),
      },
      {
        path: 'aiMonitorSetting',
        name: 'aiMonitorSetting',
        meta: {
          title: 'AI训练指导',
        },
        component: () => import('@/views/aiMonitorSetting/index.vue'),
      },
      {
        path: 'record',
        name: 'Record',
        meta: {
          title: '训练记录',
        },
        component: () => import('@/views/record/index.vue'),
      },
      {
        path: '/changeRecord',
        name: 'ChangeRecord',
        meta: {
          title: '切换档案',
        },
        component: () => import('@/views/changeRecord/index.vue'),
      },
      {
        path: '/createRecord',
        name: 'createRecord',
        meta: {
          title: '新建档案',
        },
        component: () => import('@/views/createRecord/index.vue'),
      },
    ],
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('@/views/policy/index.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
  },
  {
    path: '/iframe-train',
    name: 'IframeTrain',
    component: () => import('@/views/iframe/train.vue'),
  },
  // {
  //   path: '/iframe-exam',
  //   name: 'IframeExam',
  //   component: () => import('@/views/iframe/exam.vue'),
  // },
  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/download/index.vue'),
  },
  {
    path: '/train-schedule',
    name: 'TrainSchedule',
    component: () => import('@/views/trainSchedule/index.vue'),
  },
  {
    path: '/train-schedule-detail',
    name: 'TrainScheduleDetail',
    component: () => import('@/views/trainScheduleDetail/index.vue'),
  },
  {
    path: '/train-schedule-edit',
    name: 'TrainScheduleEdit',
    component: () => import('@/views/trainScheduleEdit/index.vue'),
    meta:{keepAlive:true}
  },
  {
    path: '/train-schedule-type',
    name: 'TrainScheduleType',
    component: () => import('@/views/trainScheduleType/index.vue'),
  },
];
